import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Lock } from "lucide-react";
import type { User } from "@supabase/supabase-js";

export const SKOOL_JOIN_URL = "https://www.skool.com/ai-automations-by-hector-8106/about";

/**
 * The "Members only" panel shared by the gated resource pages (Classroom Library, Community
 * Resource). Lists what is behind the gate and offers the three ways in: sign in, a plan, or
 * the Skool community (whose members sync here within a day).
 */
const MembersOnlyBox = ({
  user,
  items = [],
  note,
}: {
  user: User | null | undefined;
  /** Teaser labels of what the member would get (file names, "6 images"…). */
  items?: string[];
  /** Optional one-liner under the title, e.g. what kind of content is gated. */
  note?: string;
}) => (
  <div className="rounded-lg border border-dashed border-border p-4">
    <div className="flex items-center gap-2 text-sm font-medium text-foreground mb-2">
      <Lock className="w-4 h-4 text-primary" /> Members only
    </div>
    {note ? <p className="text-sm text-muted-foreground mb-3">{note}</p> : null}
    {items.length ? (
      <ul className="text-sm text-muted-foreground list-disc pl-5 space-y-1 mb-4">
        {items.map((label, i) => (
          <li key={`${label}-${i}`}>{label}</li>
        ))}
      </ul>
    ) : null}
    {!user ? (
      <Link to="/auth">
        <Button className="w-full mb-2">Sign in</Button>
      </Link>
    ) : null}
    <a href="/#pricing">
      <Button variant={user ? "default" : "outline"} className="w-full mb-2">
        See the plans
      </Button>
    </a>
    <a href={SKOOL_JOIN_URL} target="_blank" rel="noopener noreferrer">
      <Button variant="ghost" className="w-full">
        Or join on Skool, $47/month
      </Button>
    </a>
    <p className="mt-3 text-xs text-muted-foreground">
      Skool members: sign in here with the same email and access syncs within a day.
    </p>
  </div>
);

export default MembersOnlyBox;
